import { ADD_UNREAD_BOOLEAN } from '../actions/unreadMessageAction';

const unreadMessageReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_UNREAD_BOOLEAN:
      return {
        ...state,
        unreadBoolean: action.unreadBoolean,
      };
    default:
      return state;
  }
};
export default unreadMessageReducer;
